import { StatusComponent } from '@efexteam/components';
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import { IconButton, Stack, Typography } from '@mui/material';
import PaymentsTableStyle from '@pages/payables/components/paymentsTable/PaymentsTable.style';
import { getDueDateStatus } from '@pages/payables/constants/status';
import { States } from '@pages/payables/types/paymentStatus.type';
import { capitalizeFirst } from '@utils/formater';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TransferHeaderProps } from '../../types';

const TransferHeader = ({ beneficiaryName, status }: TransferHeaderProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Stack direction="row" alignItems="center" gap={2}>
        <IconButton onClick={() => navigate(-1)}>
          <KeyboardArrowLeftOutlinedIcon />
        </IconButton>
        <Typography variant="h6">{beneficiaryName}</Typography>
        <StatusComponent
          size="small"
          displayVariant="chip"
          status={getDueDateStatus(capitalizeFirst(status) as States)}
          label={t(
            `state${capitalizeFirst(status)
              .toLowerCase()
              .split('_')
              .map((value) => capitalizeFirst(value))
              .join('')}`
          )}
          className={PaymentsTableStyle.DateWrapper}
        />
      </Stack>
    </Stack>
  );
};

export default TransferHeader;
